import React from "react";
import DashboardHeader from '../../components/admincomponents/DashboardHeader';
import AddNewShareholder from '../../components/admincomponents/AddNewShareholder';

function AddProject({onLogout}) {
  return (
    <>
      <DashboardHeader onLogout={onLogout}/>
      <AddNewShareholder />            
    </>
  );
}

export default AddProject;
